import {
  ACHIEVEMENT_LEVEL_KO,
  type AchievementLevel,
  type StudentConceptChipAchievement,
} from '@mathflat/domain/Achievement'
import type { ConceptChip } from '@mathflat/domain/ConceptChip'
import type { Student } from '@mathflat/domain/Student'

/** 유형칩 하나와 그 학생(또는 그룹 평균)의 성취도. 개인 유형분석과 그룹 유형분석이 함께 쓴다 */
export class AchievementConceptChip {
  id: ConceptChip['conceptChipId']

  orderingNumber: ConceptChip['orderingNumber']
  conceptChipId: ConceptChip['conceptChipId']
  conceptChipType: ConceptChip['conceptChipType']
  recommended: ConceptChip['recommended']
  bigChapterId: ConceptChip['bigChapterId']
  bigChapterName: ConceptChip['bigChapterName']
  middleChapterId: ConceptChip['middleChapterId']
  middleChapterName: ConceptChip['middleChapterName']
  littleChapterId: ConceptChip['littleChapterId']
  littleChapterName: ConceptChip['littleChapterName']
  conceptId: ConceptChip['conceptId']
  conceptName: ConceptChip['conceptName']
  repProblem: ConceptChip['repProblem']

  achievementLevel: AchievementLevel

  studentId?: Student['id']
  latestStudyLog?: StudentConceptChipAchievement['latestStudyLog']

  constructor(data: Omit<AchievementConceptChip, 'koAchievementLevel'>) {
    this.id = data.id
    this.orderingNumber = data.orderingNumber
    this.conceptChipId = data.conceptChipId
    this.conceptChipType = data.conceptChipType
    this.recommended = data.recommended
    this.bigChapterId = data.bigChapterId
    this.bigChapterName = data.bigChapterName
    this.middleChapterId = data.middleChapterId
    this.middleChapterName = data.middleChapterName
    this.littleChapterId = data.littleChapterId
    this.littleChapterName = data.littleChapterName
    this.conceptId = data.conceptId
    this.conceptName = data.conceptName
    this.repProblem = data.repProblem
    this.achievementLevel = data.achievementLevel
    this.studentId = data.studentId
    this.latestStudyLog = data.latestStudyLog
  }

  get koAchievementLevel() {
    return ACHIEVEMENT_LEVEL_KO[this.achievementLevel]
  }
}
